<script setup>
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useMapGetter, useStore } from 'dashboard/composables/store';
import { useAlert } from 'dashboard/composables';
import Button from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  conversationId: {
    type: [Number, String],
    required: true,
  },
});

const { t } = useI18n();
const store = useStore();
const currentUser = useMapGetter('getCurrentUser');

const isSuperAdmin = computed(() => currentUser.value.type === 'SuperAdmin');
const showConfirm = ref(false);
const isLoading = ref(false);

const onReset = async () => {
  isLoading.value = true;
  try {
    await store.dispatch('resetAgentChat', props.conversationId);
    useAlert(t('CONVERSATION_SIDEBAR.AGENT_CHAT_ADMIN.SUCCESS'));
  } catch {
    useAlert(t('CONVERSATION_SIDEBAR.AGENT_CHAT_ADMIN.RELAY_ERROR'));
  } finally {
    isLoading.value = false;
    showConfirm.value = false;
  }
};
</script>

<template>
  <div
    v-if="isSuperAdmin"
    class="mx-2 mt-2 mb-4 rounded-lg border border-n-weak p-3"
  >
    <p class="text-xs font-medium text-n-slate-11 uppercase tracking-wide mb-3">
      {{ $t('CONVERSATION_SIDEBAR.AGENT_CHAT_ADMIN.TITLE') }}
    </p>
    <div v-if="!showConfirm">
      <Button size="sm" color="slate" @click="showConfirm = true">
        {{ $t('CONVERSATION_SIDEBAR.AGENT_CHAT_ADMIN.RESET_BUTTON') }}
      </Button>
    </div>
    <div v-else class="flex flex-col gap-2">
      <p class="text-xs text-n-slate-11">
        {{ $t('CONVERSATION_SIDEBAR.AGENT_CHAT_ADMIN.CONFIRM_HINT') }}
      </p>
      <div class="flex gap-2">
        <Button size="sm" color="ruby" :is-loading="isLoading" @click="onReset">
          {{ $t('CONVERSATION_SIDEBAR.AGENT_CHAT_ADMIN.CONFIRM_LABEL') }}
        </Button>
        <Button
          size="sm"
          color="slate"
          variant="ghost"
          @click="showConfirm = false"
        >
          {{ $t('CONVERSATION_SIDEBAR.AGENT_CHAT_ADMIN.CANCEL') }}
        </Button>
      </div>
    </div>
  </div>
</template>
